module.exports = __webpack_public_path__ + "images/favicon-tit2025.ico";